import { NavLink } from 'react-router-dom';
import { ChevronDoubleLeftIcon, DashboardIcon, ReconciliationIcon, TransactionsIcon, UsersIcon } from "../../pages/Utils";
import './style.scss';

// --- Sidebar Content Component (tái sử dụng cho cả Drawer và Sidebar) ---
export const SidebarContent = ({ closeSidebar, isCollapsed, toggleCollapse, isMobile = false }: any) => {
    const navItems = [
        { id: 'dashboard', path: '/dashboard', label: 'Dashboard', icon: <DashboardIcon /> },
        { id: 'users', path: '/users', label: 'Users', icon: <UsersIcon /> },
        { id: 'transactions', path: '/transactions', label: 'Transactions', icon: <TransactionsIcon /> },
        { id: 'reconciliation', path: '/reconciliation', label: 'Reconciliation', icon: <ReconciliationIcon /> },
    ];

    const handleNavClick = () => {
        if (isMobile) {
            closeSidebar();
        }
    };

    return (
        <>
            <div className={`sidebar-header ${isCollapsed ? 'collapsed' : ''}`}>
                <div className="sidebar-logo-wrapper">
                    <div className="sidebar-logo">M</div>
                    {!isCollapsed && (
                        <div className="sidebar-logo-text">
                            <h1>PWC Partner</h1>
                            <p>Meteora Pay</p>
                        </div>
                    )}
                </div>
                {!isMobile && (
                    <div className="sidebar-collapse-button-wrapper">
                        <button onClick={toggleCollapse} className="sidebar-collapse-button">
                            <ChevronDoubleLeftIcon className={`icon ${isCollapsed ? 'collapsed' : ''}`} />
                        </button>
                    </div>
                )}
            </div>
            <nav className={`sidebar-nav ${isCollapsed ? 'collapsed' : ''}`}>
                {navItems.map(item => (
                    <NavLink
                        key={item.id}
                        to={item.path}
                        onClick={handleNavClick}
                        title={isCollapsed ? item.label : undefined}
                        className={({ isActive }) =>
                            `sidebar-item ${isActive ? 'active' : ''} ${isCollapsed ? 'collapsed' : ''}`
                        }
                    >
                        {item.icon}
                        {!isCollapsed && <span>{item.label}</span>}
                    </NavLink>
                ))}
            </nav>
        </>
    );
};

// --- Sidebar Component (chỉ cho desktop) ---
const Sidebar = ({ closeSidebar, isCollapsed, toggleCollapse }: any) => {
    return (
        <aside className="sidebar">
            <SidebarContent
                closeSidebar={closeSidebar}
                isCollapsed={isCollapsed}
                toggleCollapse={toggleCollapse}
                isMobile={false}
            />
        </aside>
    );
};

export default Sidebar;
